import {
  Activity,
  ALargeSmall,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArchiveRestore,
  ArrowDown,
  ArrowDownWideNarrow,
  ArrowLeft,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  ArrowUpRight,
  AtSign,
  Award,
  BadgeCheck,
  BarChart3,
  Bell,
  Bike,
  Bold,
  BookOpen,
  Bookmark,
  Box,
  Boxes,
  Braces,
  Briefcase,
  Bug,
  Building2,
  Calculator,
  Camera,
  ChartColumnIncreasing,
  ChartPie,
  Calendar,
  CalendarCheck,
  CalendarClock,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  ChevronsUpDown,
  CircleArrowDown,
  CircleChevronDown,
  Circle,
  CircleDashed,
  CircleDot,
  CirclePause,
  CirclePlus,
  CircleSlash,
  CircleUser,
  Clipboard,
  ClipboardCheck,
  Clock,
  Code,
  Coffee,
  Crosshair,
  Columns2,
  Columns3,
  Contact,
  Copy,
  CornerUpRight,
  DatabaseZap,
  Download,
  DollarSign,
  Donut,
  DoorClosed,
  Ellipsis,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCode,
  FileQuestionMark,
  FileText,
  Flag,
  Flame,
  FolderKanban,
  GitBranch,
  GitMerge,
  Globe,
  GripVertical,
  Hash,
  Hammer,
  Hourglass,
  Gift,
  Heart,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  HeartHandshake,
  HelpCircle,
  History,
  Home,
  Image,
  Inbox,
  IndentIncrease,
  IndentDecrease,
  Info,
  Italic,
  Keyboard,
  LayoutDashboard,
  LayoutGrid,
  Landmark,
  Layers,
  Lightbulb,
  Lock,
  Link,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  Loader2,
  LogOut,
  Mail,
  MapPin,
  Maximize,
  Maximize2,
  Medal,
  Menu,
  MessageSquare,
  MessageSquareDot,
  Moon,
  Minimize2,
  Minus,
  Monitor,
  MoreHorizontal,
  MoreVertical,
  MousePointerClick,
  Navigation,
  Orbit,
  Package,
  Palette,
  PanelRight,
  PanelRightClose,
  Paperclip,
  PawPrint,
  Pencil,
  PenLine,
  Percent,
  PenTool,
  PersonStanding,
  Phone,
  Pickaxe,
  PiggyBank,
  Pilcrow,
  PlayCircle,
  Plug,
  Plus,
  Power,
  PowerOff,
  Radar,
  RefreshCw,
  Quote,
  Redo2,
  Replace,
  Reply,
  Repeat,
  Rocket,
  RotateCcw,
  Ruler,
  Save,
  SaveCheck,
  ScrollText,
  Search,
  SearchX,
  Send,
  Settings,
  Shapes,
  Share2,
  Shield,
  SkipBack,
  SkipForward,
  SlidersHorizontal,
  Smartphone,
  Smile,
  SmilePlus,
  Sparkles,
  Speech,
  Split,
  Square,
  SquareArrowDown,
  SquareCheck,
  SquareCode,
  Star,
  Strikethrough,
  Sun,
  SunMoon,
  Table,
  TableProperties,
  Tablet,
  Tag,
  Target,
  Text,
  TextCursorInput,
  TextSelect,
  Timer,
  ThumbsUp,
  Trash2,
  TreePine,
  Type,
  TrendingUp,
  TriangleAlert,
  Trophy,
  Truck,
  Undo2,
  Underline,
  Unlink,
  User,
  UserCircle,
  UserLock,
  UserPlus,
  Users,
  Volume2,
  WandSparkles,
  Webhook,
  Wifi,
  WifiOff,
  Workflow,
  Wrench,
  X,
  XCircle,
  Zap,
  ZapOff,
  ZoomIn,
  ZoomOut,
} from "lucide-react";
import { GoogleLogo, GridDots } from "./custom-icons";

export type { LucideIcon, LucideProps } from "lucide-react";

export const ICON_REGISTRY = {
  "a-large-small": ALargeSmall,
  "activity": Activity,
  "align-left": AlignLeft,
  "align-center": AlignCenter,
  "align-right": AlignRight,
  "alert-circle": AlertCircle,
  "alert-triangle": AlertTriangle,
  "apartment": Building2,
  "archive": Archive,
  "archive-restore": ArchiveRestore,
  "arrow-down": ArrowDown,
  "arrow-down-wide-narrow": ArrowDownWideNarrow,
  "arrow-left": ArrowLeft,
  "arrow-left-to-line": ArrowLeftToLine,
  "arrow-right": ArrowRight,
  "arrow-right-left": ArrowRightLeft,
  "arrow-up": ArrowUp,
  "arrow-up-right": ArrowUpRight,
  "at-sign": AtSign,
  "award": Award,
  "badge-check": BadgeCheck,
  "bar-chart": BarChart3,
  "bar-chart-3": BarChart3,
  "chart-column-increasing": ChartColumnIncreasing,
  "chart-pie": ChartPie,
  "bell": Bell,
  "bike": Bike,
  "bold": Bold,
  "book-open": BookOpen,
  "bookmark": Bookmark,
  "box": Box,
  "boxes": Boxes,
  "braces": Braces,
  "briefcase": Briefcase,
  "bug": Bug,
  "building": Building2,
  "building-2": Building2,
  "calculator": Calculator,
  "camera": Camera,
  "calendar": Calendar,
  "calendar-check": CalendarCheck,
  "calendar-clock": CalendarClock,
  "check": Check,
  "check-circle": CheckCircle,
  "check-circle-2": CheckCircle2,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  "chevrons-down": ChevronsDown,
  "chevrons-down-up": ChevronsDownUp,
  "chevrons-left": ChevronsLeft,
  "chevrons-right": ChevronsRight,
  "chevrons-up": ChevronsUp,
  "chevrons-up-down": ChevronsUpDown,
  "circle-arrow-down": CircleArrowDown,
  "circle-chevron-down": CircleChevronDown,
  "circle": Circle,
  "circle-dashed": CircleDashed,
  "circle-dot": CircleDot,
  "circle-pause": CirclePause,
  "circle-plus": CirclePlus,
  "circle-slash": CircleSlash,
  "circle-user": CircleUser,
  "clipboard": Clipboard,
  "clipboard-check": ClipboardCheck,
  "clock": Clock,
  "code": Code,
  "coffee": Coffee,
  "crosshair": Crosshair,
  "columns-2": Columns2,
  "columns-3": Columns3,
  "contact": Contact,
  "copy": Copy,
  "corner-up-right": CornerUpRight,
  "database-zap": DatabaseZap,
  "dollar-sign": DollarSign,
  "donut": Donut,
  "door-closed": DoorClosed,
  "download": Download,
  "ellipsis": Ellipsis,
  "external-link": ExternalLink,
  "file": File,
  "eye": Eye,
  "eye-off": EyeOff,
  "file-code": FileCode,
  "file-question-mark": FileQuestionMark,
  "file-text": FileText,
  "filter": ListFilter,
  "flag": Flag,
  "flame": Flame,
  "folder-kanban": FolderKanban,
  "git-branch": GitBranch,
  "git-merge": GitMerge,
  "globe": Globe,
  "google": GoogleLogo,
  "orbit": Orbit,
  "grid-dots": GridDots,
  "grip-vertical": GripVertical,
  "hash": Hash,
  "hammer": Hammer,
  "hourglass": Hourglass,
  "heading-1": Heading1,
  "heading-2": Heading2,
  "heading-3": Heading3,
  "heading-4": Heading4,
  "indent-increase": IndentIncrease,
  "indent-decrease": IndentDecrease,
  "redo-2": Redo2,
  "gift": Gift,
  "heart": Heart,
  "heart-handshake": HeartHandshake,
  "help-circle": HelpCircle,
  "history": History,
  "home": Home,
  "image": Image,
  "inbox": Inbox,
  "info": Info,
  "italic": Italic,
  "keyboard": Keyboard,
  "layout-dashboard": LayoutDashboard,
  "layout-grid": LayoutGrid,
  "landmark": Landmark,
  "layers": Layers,
  "lock": Lock,
  "lightbulb": Lightbulb,
  "link": Link,
  "list": List,
  "list-checks": ListChecks,
  "list-filter": ListFilter,
  "list-ordered": ListOrdered,
  "loader": Loader2,
  "log-out": LogOut,
  "mail": Mail,
  "map-pin": MapPin,
  "maximize": Maximize,
  "maximize-2": Maximize2,
  "medal": Medal,
  "menu": Menu,
  "message-square": MessageSquare,
  "message-square-dot": MessageSquareDot,
  "minimize-2": Minimize2,
  "minus": Minus,
  "monitor": Monitor,
  "moon": Moon,
  "more-horizontal": MoreHorizontal,
  "more-vertical": MoreVertical,
  "mouse-pointer-click": MousePointerClick,
  "navigation": Navigation,
  "package": Package,
  "deployed_code": Package,
  "palette": Palette,
  "paperclip": Paperclip,
  "panel-right": PanelRight,
  "panel-right-close": PanelRightClose,
  "paw-print": PawPrint,
  "pen-line": PenLine,
  "pen-tool": PenTool,
  "pencil": Pencil,
  "percent": Percent,
  "person-standing": PersonStanding,
  "phone": Phone,
  "pickaxe": Pickaxe,
  "piggy-bank": PiggyBank,
  "pillcrow": Pilcrow,
  "play-circle": PlayCircle,
  "plug": Plug,
  "plus": Plus,
  "power": Power,
  "power-off": PowerOff,
  "quote": Quote,
  "radar": Radar,
  "refresh-cw": RefreshCw,
  "replace": Replace,
  "reply": Reply,
  "repeat": Repeat,
  "rocket": Rocket,
  "rotate-ccw": RotateCcw,
  "ruler": Ruler,
  "save": Save,
  "save-check": SaveCheck,
  "scroll-text": ScrollText,
  "search": Search,
  "search-x": SearchX,
  "send": Send,
  "settings": Settings,
  "shapes": Shapes,
  "share-2": Share2,
  "shield": Shield,
  "skip-back": SkipBack,
  "skip-forward": SkipForward,
  "sliders-horizontal": SlidersHorizontal,
  "smartphone": Smartphone,
  "smile": Smile,
  "smile-plus": SmilePlus,
  "sparkles": Sparkles,
  "speech": Speech,
  "split": Split,
  "square": Square,
  "square-arrow-down": SquareArrowDown,
  "square-check": SquareCheck,
  "square-code": SquareCode,
  "star": Star,
  "strikethrough": Strikethrough,
  "sun": Sun,
  "sun-moon": SunMoon,
  "table": Table,
  "table-properties": TableProperties,
  "tablet": Tablet,
  "tag": Tag,
  "target": Target,
  "text": Text,
  "text-cursor-input": TextCursorInput,
  "text-select": TextSelect,
  "timer": Timer,
  "thumbs-up": ThumbsUp,
  "trash-2": Trash2,
  "tree-pine": TreePine,
  "type": Type,
  "trending-up": TrendingUp,
  "triangle-alert": TriangleAlert,
  "trophy": Trophy,
  "truck": Truck,
  "undo-2": Undo2,
  "underline": Underline,
  "unlink": Unlink,
  "user": User,
  "user-circle": UserCircle,
  "user-lock": UserLock,
  "user-plus": UserPlus,
  "users": Users,
  "volume-2": Volume2,
  "wand-sparkles": WandSparkles,
  "webhook": Webhook,
  "wifi": Wifi,
  "wifi-off": WifiOff,
  "workflow": Workflow,
  "wrench": Wrench,
  "x": X,
  "zoom-in": ZoomIn,
  "zoom-out": ZoomOut,
  "x-circle": XCircle,
  "zap": Zap,
  "zap-off": ZapOff,
} as const;

export type IconName = keyof typeof ICON_REGISTRY;
